/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Member_Total_TokensInputs */



/**
* | output |
* | --- |
* | "Total Tokens" |
*
* @param {Dashboard_Member_Total_TokensInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_member_total_tokens = /** @type {((inputs?: Dashboard_Member_Total_TokensInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Member_Total_TokensInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tokens gesamt")
	return /** @type {LocalizedString} */ ("Total Tokens")
});